import { SfSelectOption } from 'ngx-smart-form';
import { SagittaScoreElement } from './sagitta-score-element';
import { SagittaScoreArea } from './sagitta-score-area';
import { SagittaScoreFactory } from './sagitta-score-factory';
import { SagittaScoreRowDto } from '../dto/sagitta-score-row-dto';
import { SectionId } from '../configs/section-id-enum';

export class SagittaScoreRow {
  constructor(
    public description: string,
    public elements: SagittaScoreElement[]
  ) {}

  static genDto(
    row: SagittaScoreRow,
    area: SagittaScoreArea['area']
  ): SagittaScoreRowDto {
    let r = {
      description: row.description,
      elements: row.elements.map((el) => {
        let selectionValue: string | number | null = null;
        if (
          el.field.controlRef?.value !== undefined &&
          el.field.controlRef?.value !== null
        ) {
          if (area === 'A' && el.id !== SectionId.identificazioneDelSettore) {
            selectionValue = el.field.controlRef?.value === 1 ? 'SI' : 'NO';
          } else {
            selectionValue = el.field.controlRef?.value;
          }
        }
        return {
          description: el.description,
          kriPoints: SagittaScoreFactory.round(el.kriPoints) || 0,
          kriWeight: el.kriWeight || 0,
          id: el.id,
          selectionValue: selectionValue,
        };
      }),
    };
    return r;
  }

  static buildRow(
    description: string,
    options: SfSelectOption<number>[] | undefined = undefined,
    kriWeight: number | undefined,
    rowId: string | undefined,
    sectionId: string,
    sectionWeight: number,
    classLevel: SagittaScoreArea['area'],
    dtoRow?: { description: string; elements: Partial<SagittaScoreElement>[] },
    elements: Partial<SagittaScoreElement>[] = [{}]
  ) {
    let row: SagittaScoreRow = {
      description,
      elements: elements
        .map((el, i) => ({ ...el, ...dtoRow?.elements[i] }))
        .map((el, i) =>
          SagittaScoreFactory.buildElement(
            el,
            el.id || rowId || sectionId,
            classLevel,
            el.kriWeight || kriWeight || 0,
            sectionWeight,
            el.options || options
          )
        ),
    };
    return row;
  }
}
